import { parseISO } from 'date-fns';

import { ReviewSolicitationApiData } from '../../types/review-solicitation';

export interface ReviewSolicitationData {
	userId: string;
	shouldSolicit: boolean;
	lastSolicitedAt: Date | null;
	g2ReviewLink: string;
	incentivized: boolean;
}

export class ReviewSolicitation {
	userId: string;
	shouldSolicit: boolean;
	lastSolicitedAt: Date | null;
	g2ReviewLink: string;
	incentivized: boolean;

	constructor(data: ReviewSolicitationData) {
		this.userId = data.userId;
		this.shouldSolicit = data.shouldSolicit;
		this.lastSolicitedAt = data.lastSolicitedAt;
		this.g2ReviewLink = data.g2ReviewLink;
		this.incentivized = data.incentivized;
	}

	public static fromApiData(data: ReviewSolicitationApiData) {
		return new ReviewSolicitation({
			userId: data.userId,
			shouldSolicit: data.shouldSolicit,
			lastSolicitedAt: data.lastSolicitedAt ? parseISO(data.lastSolicitedAt) : null,
			g2ReviewLink: data.g2ReviewLink,
			incentivized: data.incentivized ?? false,
		});
	}
}
